export const SDK_VERSION = '6.6.0';
